import React from "react";
import { Box, Typography } from "@mui/material";
import { formatWhatsAppText } from "../../utils/whatsappTextFormat";

const TextMessage = ({ message, textOverride }) => {
  const html = formatWhatsAppText(textOverride != null ? textOverride : message?.text);
  return (
    <Box>
      <Typography
        component="div"
        dangerouslySetInnerHTML={{ __html: html }}
        sx={{
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
          maxWidth: "100%",
          "& a": { color: "primary.main", wordBreak: "break-all" },
          "& code": { fontFamily: "monospace", fontSize: "0.9em" },
          "& img, & video, & audio, & iframe, & table, & div": {
            maxWidth: "100%",
            boxSizing: "border-box",
          },
        }}
      />
    </Box>
  );
};

export default TextMessage;
